var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isValidCertificate)?_c('div',[_c('h5',[_vm._v("Сертификат специалиста:")]),_c('p',[_vm._v(" "+_vm._s(_vm.composedCertificate)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }